import { render, staticRenderFns } from "./viewTreatmentHistoryDetailButton.vue?vue&type=template&id=35f5788c&"
import script from "./viewTreatmentHistoryDetailButton.vue?vue&type=script&lang=js&"
export * from "./viewTreatmentHistoryDetailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports